import * as Sentry from '@sentry/react';

const WEB_DEV_KEY = process.env.APPSFLYER_WEB_DEV_KEY;

if (WEB_DEV_KEY) {
  try {
    // @SONAR_STOP@
    /* eslint-disable func-names */
    /* eslint-disable @typescript-eslint/no-unused-expressions */
    !(function (t, e, n, s, a, c, i, o, p) {
      t.AppsFlyerSdkObject = a;
      t.AF =
        t.AF ||
        function () {
          (t.AF.q = t.AF.q || []).push([Date.now()].concat(Array.prototype.slice.call(arguments)));
        };
      t.AF.id = t.AF.id || i;
      t.AF.plugins = {};
      o = e.createElement(n);
      p = e.getElementsByTagName(n)[0];
      o.async = 1;
      o.src =
        'https://websdk.appsflyer.com?' +
        (c.length > 0 ? 'st=' + c.split(',').sort().join(',') + '&' : '') +
        (i.length > 0 ? 'af_id=' + i : '');
      o.onerror = function (err) {
        Sentry.captureException(err);
      };
      p.parentNode.insertBefore(o, p);
    })(window, document, 'script', 0, 'AF', 'pba', {
      pba: { webAppId: WEB_DEV_KEY },
    });
    /* eslint-enable func-names */
    /* eslint-enable @typescript-eslint/no-unused-expressions */
    // @SONAR_START@
  } catch (e) {
    Sentry.addBreadcrumb({
      level: 'error',
      category: 'appsFlyerSdk',
      message: e.message,
    });
  }
}
